import { OFFLINE_LABEL } from '@/shared/constants/offline-label.constant';

export const transformSeconds = (seconds: number) => {
	if (seconds > 300) {
		return OFFLINE_LABEL;
	}

	if (seconds <= 0) {
		return '00:00';
	}

	const totalSeconds = Math.floor(seconds);
	const min = Math.floor(totalSeconds / 60);
	const sec = totalSeconds % 60;

	return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
};
